import React, { useState, useEffect, useCallback } from 'react';

import { FiChevronLeft, FiChevronRight, FiRefreshCw } from 'react-icons/fi';
import KIChart from './KIChart';
import getScoreTextKISelbtest from '../../../utils/getScoreTextKISelbtest';

import chartRiskCultureReadinessScoreOrange from '../../../assets/background-KI-Aktuell.png';

import {
  Wrap,
  Container,
  ChartContainer,
  LeftContainer,
  TextContainer,
  Header,
  HeaderLine,
  Score,
  Body,
  BodyLine,
  RefreshButton,
  ButtonLeft,
  ButtonRight,
  BottomContainer,
  BoxFooter,
  SvgWrapper,
  ChartWrapper,
  SubTitle,
} from './styles';

import api from '../../../services/api';

interface Topic {
  name: string;
  category: string;
  score: number;
  questionId?: number;
  topics?: Topic[];
}

interface Props {
  surveyId: number;
  resultId?: number;
  pinkBackground?: boolean;
}

const size = '100%';
const colors = ['#98E3DA', '#4DC9BF', '#3C9991'];
const stroke = 'none';
const strokeWidth = 0;
const className = '';
const title = 'Concentric circles';
const viewBoxSize = 100;
const radii = { outer: 48, middle: 32, inner: 16 };

const KiChartContainer: React.FC<Props> = props => {
  const [structure, setStructure] = useState<Topic[]>([]);
  const [currentAPillar, setCurrentAPillar] = useState<Topic>();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [forceUpdateValue, setForceUpdateValue] = useState(0);
  const [imageBackGround, setImageBackGround] = useState('');

  useEffect(() => {
    setImageBackGround(`${chartRiskCultureReadinessScoreOrange}`);

    const url = props.resultId
      ? `/results/${props.resultId}/survey/${props.surveyId}/scoreResults`
      : `/results/survey/${props.surveyId}/scoreResults`;

    api.get(url).then(response => {
      setStructure(response.data);
      setCurrentAPillar(response.data[currentIndex]);
    });
  }, [forceUpdateValue, currentIndex, props, currentAPillar?.name]);

  const handleRefresh = useCallback(() => {
    setForceUpdateValue(forceUpdateValue + 1);
  }, [forceUpdateValue]);

  const handlePrev = useCallback(() => {
    setCurrentAPillar(structure[currentIndex - 1]);
    setCurrentIndex(currentIndex - 1);
  }, [structure, currentIndex]);

  const handleNext = useCallback(() => {
    setCurrentAPillar(structure[currentIndex + 1]);
    setCurrentIndex(currentIndex + 1);
  }, [structure, currentIndex]);

  return (
    <Wrap id="wrap">
      {!props.resultId && (
        <>
          <RefreshButton type="button" onClick={handleRefresh}>
            <FiRefreshCw size={30} />
          </RefreshButton>
        </>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginLeft: 30,
          marginRight: 70,
          color: '#f2efeb',
        }}
      >
        <h1>KI-21 Schnell-Check</h1>
        <h2>
          {`Du erreichst einen Gesamtscore von: ${
            currentAPillar ? Math.round(currentAPillar.score) : 'k/a'
          }`}
        </h2>
        <h3>
          <Header>
            <>
              <span>
                {currentAPillar?.name === 'Risk Culture Readiness Score'
                  ? 'Es muss eine KULTUR geschaffen werden, in der Mitarbeiter sich der Risiken des TUNS und UNTERLASSENS bewusst sind. Darüber hinaus ist es wichtig, dass sich die Risikokultur für alle Mitarbeiter „richtig“ anfühlt und sie das Thema mit einem positiven Zugang BEWERTEN.'
                  : currentAPillar?.score
                  ? getScoreTextKISelbtest(Math.round(currentAPillar.score))
                      .title
                  : 'Es konnten noch keine Scores berechnet werden, da noch keine Daten vorliegen.'}
              </span>
              <p>
                {currentAPillar?.name === 'Risk Culture Readiness Score'
                  ? 'Es muss eine KULTUR geschaffen werden, in der Mitarbeiter sich der Risiken des TUNS und UNTERLASSENS bewusst sind. Darüber hinaus ist es wichtig, dass sich die Risikokultur für alle Mitarbeiter „richtig“ anfühlt und sie das Thema mit einem positiven Zugang BEWERTEN.'
                  : currentAPillar?.score
                  ? getScoreTextKISelbtest(Math.round(currentAPillar.score))
                      .text
                  : 'Es konnten noch keine Scores berechnet werden, da noch keine Daten vorliegen.'}
              </p>
            </>
          </Header>
          {currentIndex > 0 && (
            <ButtonLeft type="button" onClick={handlePrev}>
              <FiChevronLeft size={60} />
            </ButtonLeft>
          )}
        </h3>
      </div>
      <Container id="containerChartKi">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        ></div>
        <ChartContainer
          id="chartContainerId"
          $APillarName={
            currentAPillar?.name === 'Dein Gesamt-Punkte-Ergebnis'
              ? 'apillar1'
              : 'apillar2'
          }
          $imageBackGround={imageBackGround}
        >
          <KIChart
            title={
              props.resultId
                ? 'Ihr Wert'
                : currentAPillar
                ? currentAPillar.name
                : 'k/a'
            }
            itens={
              currentAPillar?.topics &&
              currentAPillar.topics.flatMap((topic: Topic) => {
                return topic.name.split(' - ')[0];
              })
            }
            values={
              currentAPillar?.topics &&
              currentAPillar.topics.flatMap((topic: Topic) => {
                return Math.round(topic.score);
              })
            }
            benchmarkValues={[]}
            displayTickLabel={false}
            pinkBackground={props.pinkBackground}
          />
        </ChartContainer>
        {/* <LeftContainer>
          {currentIndex !== structure.length - 1 && (
            <ButtonRight type="button" onClick={handleNext}>
              <FiChevronRight size={60} />
            </ButtonRight>
          )}
        </LeftContainer> */}
      </Container>

      <BottomContainer>
        <TextContainer>
          <Body>
            <HeaderLine>
              <h1>{currentAPillar?.name}</h1>
              <Score>
                {currentAPillar ? Math.round(currentAPillar.score) : 'k/a'}
              </Score>
            </HeaderLine>
            <SubTitle>
              <h1>{'Asprägung pro Dimension in %:'}</h1>
            </SubTitle>
            {currentAPillar?.topics?.map((topic, i) => (
              <BodyLine
                key={i}
                $APillarName={
                  currentAPillar?.name === 'Culture Readiness Score'
                    ? 'apillar1'
                    : 'apillar2'
                }
              >
                <h3
                  style={{ flex: 1, marginRight: '20px', marginBottom: '30px' }}
                >
                  {topic.name}
                </h3>
                <h3>{topic.score ? `${Math.round(topic.score)} %` : 'k/a'}</h3>
              </BodyLine>
            ))}
          </Body>
        </TextContainer>
      </BottomContainer>
    </Wrap>
  );
};

export default KiChartContainer;
